// extracted by mini-css-extract-plugin
export default {"nav":"Nav_nav__zo9f-","logo":"Nav_logo__J8s0y"};